import React, { Fragment } from 'react'
import classNamesBind from 'classnames/bind'

import ColorIcon from '@dashboard/components/ColorIcon'

import css from './styles.module.scss'
const classNames = classNamesBind.bind(css)

interface OwnProps {
  changePage: (page: number) => void
  currentPage: number
  simple?: boolean
  noNextOrPrev?: boolean
  totalPages: number
}

export default class Pagination extends React.Component<OwnProps> {
  render() {
    const { simple, totalPages, currentPage } = this.props

    const pages: number[] = []
    for (let page = 1; page <= currentPage + 2; page++) {
      if (page <= totalPages && page >= currentPage - 2) {
        pages.push(page)
      }
    }

    return (
      <div className={classNames('pages', { simple })}>
        {this.renderArrow('prev')}
        {this.renderFirstPageLink()}

        {pages.map(num => this.renderPageLink(num))}
        {this.renderLastPageLink()}

        {this.renderArrow('next')}
      </div>
    )
  }

  // Partials
  renderArrow(direction: 'prev' | 'next') {
    const { changePage, totalPages, currentPage, noNextOrPrev } = this.props

    if (noNextOrPrev) return null

    const disabled =
      direction == 'next' ? currentPage == totalPages : currentPage == 1

    const newPage = direction == 'next' ? currentPage + 1 : currentPage - 1

    return (
      <div
        className={classNames('page', 'arrow', direction, { disabled })}
        onClick={() => changePage(newPage)}
      >
        <ColorIcon icon="arrow" width={18} discType="empty" />
      </div>
    )
  }

  renderFirstPageLink() {
    const { currentPage } = this.props

    if (currentPage == 4) return this.renderPageLink(1)
    if (currentPage < 5) return null

    return (
      <Fragment>
        {this.renderPageLink(1)}
        <div className={classNames('page', 'ellipsis')}>...</div>
      </Fragment>
    )
  }

  renderLastPageLink() {
    const { totalPages, currentPage } = this.props

    if (totalPages - currentPage == 3) return this.renderPageLink(totalPages)
    if (totalPages - currentPage < 3) return null

    return (
      <Fragment>
        <div className={classNames('page', 'ellipsis')}>...</div>
        {this.renderPageLink(totalPages)}
      </Fragment>
    )
  }

  renderPageLink(num: number) {
    const { currentPage, changePage } = this.props

    return (
      <div
        key={num}
        className={classNames('page', {
          current: num == currentPage,
        })}
        onClick={() => changePage(num)}
      >
        {num}
      </div>
    )
  }
}
